<template>
  <layout-default :hide-footer-mobile="true" :show-promo-message="false">
    <div class="buy-other-program">
      <div class="container h-100">
        <div class="main-content h-100">
          <div class="row no-gutters h-100">
            <div class="col-md-5 d-none d-md-block">
              <img class="image-left" src="/images/pdv-747.png" alt="" />
            </div>

            <div class="col-md-7 d-flex align-items-center">
              <div class="main-content-text">
                <p>SÓLO INSCRIBIÉNDOTE ONLINE</p>
                <h3>
                  {{ discount }}% DESCUENTO <br />
                </h3>

                <form
                  id="programInscription"
                  @submit.prevent="ifFormValid($event, saveFormInfo)"
                >
                  <div class="pdv-form-group pdv-form-group--white mt-4">
                    <div class="row custom-pdv-row">
                      <div class="col-md-6 custom-pdv-col">
                        <div class="form-group">
                          <label for="inscriptionName">Nombre</label>
                          <input
                            v-model="formStudent.name"
                            type="text"
                            id="inscriptionName"
                            name="nombre"
                            onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                            maxlength="30"
                          />
                        </div>
                      </div>

                      <div class="col-md-6 col-7 custom-pdv-col">
                        <div class="form-group">
                          <label for="">Apellido Paterno</label>
                          <input
                            v-model="formStudent.fatherLastName"
                            type="text"
                            id=""
                            name="apellidoPaterno"
                            maxlength="15"
                            onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-6">
                        <div class="form-group">
                          <label for="">RUT</label>
                          <vue-mask
                            v-model="formStudent.rut"
                            mask="00.000.000-K"
                            :raw="false"
                            :options="{
                              reverse: true,
                              translation: { K: { pattern: /[0-9kK]/ } }
                            }"
                            name="rut"
                          ></vue-mask>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="">Email</label>
                          <input
                            v-model="formStudent.email"
                            type="email"
                            id=""
                            name="email"
                            maxlength="50"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <div class="form-group d-block">
                          <label class="mb-2"
                            >¿Qué programa quieres tomar?</label
                          >

                          <div class="mb-md-2 mb-3 custom-radio-cont">
                            <input
                              v-model="selectedProgram"
                              :value="highSchoolAcademy"
                              class="withErrorContainer"
                              type="radio"
                              id="tradicional4Medio"
                              name="programas"
                            />

                            <label for="tradicional4Medio" class="radio-label">
                              <div class="pdv-custom-radio">
                                <img
                                  src="images/iconos/radio-selected-white.svg"
                                  alt=""
                                />
                              </div>

                              <span>Tradicional 4º Medio</span>
                            </label>
                          </div>

                          <div class="mb-2 custom-radio-cont">
                            <input
                              v-model="selectedProgram"
                              :value="bachelorsAcademy"
                              class="withErrorContainer"
                              type="radio"
                              id="academiaEgresados"
                              name="programas"
                            />

                            <label for="academiaEgresados" class="radio-label">
                              <div class="pdv-custom-radio">
                                <img
                                  src="images/iconos/radio-selected-white.svg"
                                  alt=""
                                />
                              </div>

                              <span>Academia Egresado</span>
                            </label>
                          </div>

                          <div class="errorContainer"></div>
                        </div>
                      </div>
                    </div>

                    <div class="pdv-submit-button mt-2">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="form-group">
                            <button type="submit" class="btn-pdv-primary">
                              AGREGAR ESTUDIANTE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import formValidation from "@/mixins/formValidation";
import vueMask from "vue-jquery-mask";

export default {
  components: {
    LayoutDefault,
    vueMask
  },

  data() {
    return {
      formStudent: {
        name: null,
        fatherLastName: null,
        lastName: null,
        rut: null,
        email: null
      },
      enabledPrograms: null,
      bachelorsAcademy: null,
      highSchoolAcademy: null,
      selectedProgram: null,
      discount: discount
    };
  },

  computed: {
    lastName() {
      return this.formStudent.fatherLastName;
    },
    studentsWithPrices() {
      return this.$store.state.studentsWithPrices;
    }
  },

  mixins: [formValidation],

  methods: {
    goToNextStep() {
      this.$router.push({ name: "Step1" });
    },
    loadEnabledPrograms() {
      this.Axios.get("/programs/enabled").then(response => {
        this.enabledPrograms = response.data;
        this.bachelorsAcademy = response.data[0];
        this.highSchoolAcademy = response.data[1];
      });
    },
    configureSelectedProgram(program) {
      this.$store.dispatch("addSelectedProgramInfo", program);
    },
    async saveFormInfo() {
      await this.goToStudentForm(this.selectedProgram, "Step1");
    },
    async goToStudentForm(program, formPageName) {
      const res = await this.createStudent();
      await this.$store.dispatch("addNewStudent", {
        ...this.formStudent,
        lastName: this.lastName,
        id: res.data.id
      });
      this.configureSelectedProgram(program);
      this.$router.push({ name: formPageName });
    },

    createStudent() {
      return new Promise((resolve, reject) => {
        this.formStudent.lastName = this.lastName;
        this.Axios.post("/students", this.formStudent)
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            if (error.response.status === 400) {
              console.log(error.response);
              if (
                error.response.data.message ===
                "Error - Email address already in use!"
              ) {
                alert(
                  "El correo: " +
                    error.response.data.problemField.email +
                    " ya se encuentra registrado"
                );
              }
            }
            reject(error);
          });
      });
    }
  },

  created() {
    this.Axios.get("/dashadmin/infogeneral").then(response => {
      this.discount = response.data[0].discount;
    });
    this.loadEnabledPrograms();

    if (!this.studentsWithPrices.length) {
      this.$router.push({ name: "Landing" });
    }
  },

  mounted() {
    this.validateForm(
      $("#programInscription"),
      {
        nombre: {
          required: true,
          lettersonly: true
        },

        apellidoPaterno: {
          required: true,
          lettersonly: true
        },

        apellidoMaterno: {
          required: true,
          lettersonly: true
        },

        rut: {
          required: true,
          rut: true,
          rutDuplicado: true
        },

        email: {
          minlength: 8,
          required: true,
          email: function(value, element) {
            return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
              value
            );
          }
        },

        programas: {
          required: true
        }
      },

      {
        apellidoPaterno: {
          required: "Debes ingresar tu apellido paterno",
          lettersonly: "Solo se permiten letras"
        },

        apellidoMaterno: {
          required: "Debes ingresar tu apellido materno",
          lettersonly: "Solo se permiten letras"
        },

        nombre: {
          required: "Ingresa tu nombre",
          lettersonly: "Solo se permiten letras"
        },

        rut: {
          required: "Debes ingresar el RUT",
          rut: "El RUT ingresado no es válido",
          rutDuplicado: "Este rut ya esta en la orden"
        },

        email: {
          minlength: "Debes ingresar un correo valido",
          required: "Debes ingresar un correo",
          email: "Debes ingresar un correo valido"
        },

        programas: {
          required: "Debes seleccionar un programa"
        }
      }
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.buy-other-program {
  padding-top: 120px;
  position: relative;
  height: 850px;
  background: linear-gradient(
    to right,
    rgba(174, 42, 62, 1) 0%,
    rgba(134, 68, 106, 1) 100%
  );
  @include media-breakpoint-down(sm) {
    padding-top: 95px;
    height: auto;
    padding-bottom: 125px;
  }

  .main-content {
    .custom-radio-cont {
      input[type="radio"] {
        & ~ label .pdv-custom-radio {
          box-shadow: none;
          border: 1px solid #fff;

          input[type="radio"] {
            img {
              width: 10px;
            }
          }
        }

        &:checked ~ label .pdv-custom-radio ~ span {
          @include alternative-light-regular;
          color: #fff;
        }
      }
    }

    .image-left {
      height: 865px;
      position: absolute;
      left: -305px;
      top: -80px;
    }

    .main-content-text {
      p {
        letter-spacing: 4px;
        line-height: 19px;
        margin-bottom: 0;
        @include font-medium-regular;
        color: #fff;
      }

      h3 {
        color: #fff;
        font-size: 35px;
        line-height: 42px;
        text-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        margin-bottom: 0;
        @include font-extra-bold-regular;
        @include media-breakpoint-down(sm) {
          font-size: 25px;
          line-height: 25px;
          margin-top: 20px;
        }
      }
    }
  }

  .button-fixed {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}
</style>
